import React from "react"

import { Link, navigate } from "gatsby"

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./css/FeaturedNews.min.css"



import Slider from "react-slick"
import keygen from "keygenerator"

const FeaturedNews = () => {
  return (
    <div className="FeaturedNews">
      <div className="outer-container">
        <Carousel />
      </div>
    </div>
  )
}

const Carousel = () => (
  <div className="container">
    <h2>LATEST NEWS</h2>
    <div className="FeaturedNews--block">
      <CarouselBlock />
    </div>
  </div>
)

const CarouselBlock = () => {
  let settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  }

  return (
    <Slider {...settings}>
      {slides.map((slide, i) => {
        let { title, description, logo, href,tag } = slide,
          key = keygen._();

        return (
          <div key={key} className="product-block">
            <div className="product-detail" onClick={() => navigate(href)}>
              <div className="product-logo">
                <img src={logo.default} alt={title} title={title}/>
                </div>
              <div className="product-body">
                <div className="product-tag">{tag}</div>
                <div className="product-name">
                    <Link to={href} alt={title} title={title}>{title}</Link>
                </div>
                {/* <p className="product-description" children={description} /> */}
                {/* <Link to={href} alt={title} title={title}>
                    Read More
                </Link> */}
              </div>
            </div>
          </div>
        )
      })}
    </Slider>
  )
}

const slides = [
  {
    logo: require("./images/2026/mce.jpg"),
    title: "IGCSE Global Perspectives with CommonTown AI Tutor",
    tag:"2026",
    description:"",
    href: "/news/2026/igcse-global-perspectives-with-commontown-ai-tutor",
  },

  {
    logo: require("./images/2025/edutech-asia.png"),
    title: "EduTech Asia 2025",
    tag:"2025",
    description:"",
    href: "/news/2025/edutech-asia-2025",
  },
  {
    logo: require("./images/2025/IMDA-SME-Go-Digital-Day.png"),
    title: "SMEs Go Digital Day",
    tag:"2025",
    description:"",
    href: "/news/2025/smes-go-digital-day-2025",
  },
  {
    logo: require("./images/2025/PROMS.png"),
    title: "PROMS 2025",
    tag:"2025",
    description:"",
    href: "/news/2025/proms-2025",
  },
  {
    logo: require("./images/2025/lte_3.png"),
    title: "Learning & Teaching Expo",
    tag:"2025",
    description:"2025",
    href: "/news/2025/learning-n-teaching-expo-2025",
  },
  {
    logo: require("./images/2025/SUSS_logo.jpg"),
    title: "SUSS-CommonTown Workshop",
    tag:"2025",
    description:"2025",
    href: "/news/2025/suss-commontown-workshop-2025",
  },
  {
    logo: require("./images/2025/edutech-aus.png"),
    title: "EduTech Australia 2025",
    tag:"2025",
    description:"2025",
    href: "/news/2025/edutech-australia-2025",
  },
  {
    logo: require("./images/2025/ECEE.jpg"),
    title: "ECEE Penang",
    tag:"2025",
    description:"2025",
    href: "/news/2025/ecee-penang-2025",
  },
   {
    logo: require("./images/2025/Conference_01.jpg"),
    title: "Selangor SJKC Principals Conference",
    tag:"2025",
    description: "2025",
    href: "/news/2025/selangor-sjkc-principals-conf-2025",
  },
  {
    logo: require("./images/2024/HLP.jpg"),
    title: "PCF Home Learning Portal",
    tag:"2024",
    description:"",
    href: "/news/2024/pcf-home-learning-portal-hlp",
  }
]

// News Slider


export default FeaturedNews
